import { Replace } from "@commonlibs";
import { RoleType, RoleTypes } from "ui/user/user.types";

export enum MainRoutes {
    MAIN = "/",
    USERS = "/users",
    TRANSACTIONS = "/transactions",
    PROGRAMS = "/programs",
    PARTNERS = "/partners",
    MY_PROGRAM = "/my-program",
    MY_PARTNER = "/my-partner",
    POINTS_OF_SELL = "/points-of-sell",
    ORCHESTRATOR = "/orchestrator",
    ADMINS_AND_SECURITY = "/admins-and-security",
    GIFTCARDS = "/giftcards",
}

export const RouteRoles: Record<Uppercase<Replace<Exclude<MainRoutes, MainRoutes.MAIN>, "/", "">> | "MAIN", RoleType[]> = {
    MAIN: [RoleTypes.ORGANIZATION_OWNER, RoleTypes.OPERATION_MANAGER, RoleTypes.CUSTOMER_SERVICE],
    USERS: [RoleTypes.ORGANIZATION_OWNER, RoleTypes.PROGRAM_MANAGER, RoleTypes.OPERATION_MANAGER, RoleTypes.CUSTOMER_SERVICE],
    TRANSACTIONS: [
        RoleTypes.ORGANIZATION_OWNER,
        RoleTypes.PROGRAM_MANAGER,
        RoleTypes.PARTNER,
        RoleTypes.OPERATION_MANAGER,
        RoleTypes.CUSTOMER_SERVICE,
    ],
    PROGRAMS: [RoleTypes.ORGANIZATION_OWNER, RoleTypes.OPERATION_MANAGER, RoleTypes.CUSTOMER_SERVICE],
    PARTNERS: [RoleTypes.ORGANIZATION_OWNER, RoleTypes.OPERATION_MANAGER, RoleTypes.CUSTOMER_SERVICE],
    "MY-PROGRAM": [RoleTypes.PROGRAM_MANAGER],
    "MY-PARTNER": [RoleTypes.PARTNER],
    "POINTS-OF-SELL": [RoleTypes.PARTNER],
    ORCHESTRATOR: [RoleTypes.OPERATION_MANAGER, RoleTypes.ORGANIZATION_OWNER, RoleTypes.CUSTOMER_SERVICE],
    "ADMINS-AND-SECURITY": [RoleTypes.ORGANIZATION_OWNER],
    GIFTCARDS: [RoleTypes.ORGANIZATION_OWNER, RoleTypes.OPERATION_MANAGER, RoleTypes.CUSTOMER_SERVICE],
};
